Ext.define('SA.view.ExtFloatingKeyDownHandlingToggle', {
    singleton: true,

    enabled: true,

    disable() {
        this.enabled = false;
    },

    enable() {
        this.enabled = true;
    },

    isEnabled() {
        return this.enabled;
    }
});